import { Psychology, Diamond, Webhook, SupportAgent } from '@mui/icons-material';

export const WebType = [
    {
        id: 1,
        icon: <Psychology className="processIcon" />,
        service: "Static Website Designing",
        desc: "Static web designing is perfect for a business that doesn’t need much updations and changes. With this form of design, you can make your web pages unique and creative in the best possible manner."
    },
    {
        id: 2,
        icon: <Diamond className="processIcon" />,
        service: "Dynamic Web Designing",
        desc: "The one thing that is constant in the digital market is the changing trends. According to the changing trends, your website also needs amendments in content and other features. Our dynamic websites allow you to make changes easily so that you can keep pace with the marketing trends. Another major benefit of dynamic web designing is that it scales as your business scales."
    },
    {
        id: 3,
        icon: <Webhook className="processIcon" />,
        service: "Mobile Web Designing",
        desc: "In the 21st century, almost everyone has a mobile phone. By making your website fit perfectly on every screen size, we help customers to reach your business without any hassle. Search Engines like Google, also promote websites that are mobile responsive. Getting a mobile responsive website for your business, you can reach a wider audience and increase the number of leads your business gets."
    },
    {
        id: 4,
        icon: <SupportAgent className="processIcon" />,
        service: "Custom Web Design",
        desc: "Professionally created websites that will make your customers hang around it. We represent your business in a way that makes customers stuck on your website and compels them to avail of the products & services your business offer. With custom web design, you can include the functionalities and other features you want on your website to represent your perception of your brand truly."
    },
    {
        id: 5,
        icon: <Psychology className="processIcon" />,
        service: "Responsive Web Design",
        desc: "Different people search for products & services from different devices, such as mobile phones, tablets, laptops, and desktop. By making your website compatible with all the necessary devices, we pave the path for your targeted traffic to reach your doorstep to boost your business revenue."
    },
    {
        id: 6,
        icon: <Psychology className="processIcon" />,
        service: "Ecommerce Web Design",
        desc: "In today’s era, people resort to online stores to meet their purchase requirements instead of stepping into the offline market. By creating efficiently functional eCommerce websites with a user-friendly interface, we help you improve your sales. Precise layout and soothing color schemes are used that catch the attention of users to your eCommerce website easily."
    },
    {
        id: 7,
        icon: <Diamond className="processIcon" />,
        service: "Corporate Web Design",
        desc: "Professionally created websites that will make your customers hang around it. Being a reputed web design company in Nagpur, we represent your business in a way that makes customers stuck on your website and compels them to buy the products & services your business offer."
    },
    {
        id: 8,
        icon: <Webhook className="processIcon" />,
        service: "Website Re-designing",
        desc: "The ones who don’t move with the changing trends get lost in the crowd, and the same goes for websites. We understand the fact that the marketing tactics that worked in the past may not work the same way in the future. By re-designing your website, we keep it with the current trends so that it can perfectly communicate with your present as well as potential customers."
    },
    {
        id: 9,
        icon: <SupportAgent className="processIcon" />,
        service: "Website Maintenance",
        desc: "Our experts keep on posting new content on your website to keep it fresh and effective on search engines. We ensure that you always stay way ahead of your competition to get the best out of your business."
    },
];

export default WebType